import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UserContext from "../../../context/user/UserContext";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";

const ProtectedRoute = ({ children }) => {
  const { currentUser, isUserLoading } = useContext(UserContext);
  const location = useLocation();

  if (isUserLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
